/* ============================================================
   EYEOO CUSTOM JS — assets/eyeoo-custom.js
   JS globale Ai6 per Comelstile (tema Avante 14.x).
   Pattern: additivo, mai fork dei file vendor (facets.js ecc.).
   Ci si aggancia a eventi ed elementi esistenti del tema.
   Caricato con defer da snippets/eyeoo-assets.liquid.

   STRUTTURA DEL FILE:
   1. Custom elements (definizioni pure, immuni al contesto pagina)
   2. Modulo principale EYEOO (config, moduli, init, lifecycle)
   Le define stanno IN TESTA di proposito: un errore runtime nel
   modulo principale non deve mai impedirne la registrazione.
   ============================================================ */

/* ============================================================
   EYEOO – Card colors counter (custom element)
   Riusa la sezione e la cache dell'eyeoo-color-picker (PDP):
   stessa chiave sessionStorage 'eyeoo-cp:' + tag.
   Lazy via IntersectionObserver per non sparare N fetch
   al load della collection.
   ============================================================ */
(function () {
  'use strict';
  if (window.customElements.get('eyeoo-card-colors')) return;

  var CC_CONFIG = {
    rootMargin: '200px',
    swatchSelector: '[data-eyeoo-cpr] .eyeoo-cp__swatch',
    labelSingular: 'colore',
    labelPlural: 'colori'
  };

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      io.unobserve(entry.target);
      entry.target._load();
    });
  }, { rootMargin: CC_CONFIG.rootMargin });

  class EyeooCardColors extends HTMLElement {
    connectedCallback() {
      if (this._eyeooInit) return;
      this._eyeooInit = true;
      io.observe(this);
    }

    async _load() {
      var tag = this.dataset.tag;
      if (!tag) return;

      var vendor = this.dataset.vendor || '';

      /* Query per TAG, non full-text. `?q=rc_12345` cercava nel testo:
         Shopify tokenizza sull'underscore, quindi rc_12345 diventava
         rc + 12345 e pescava prodotti di altri brand che contenevano
         uno dei due token in titolo, SKU o altri tag. Il vincolo sul
         vendor rende impossibile la contaminazione fra brand anche se
         due fornitori usassero lo stesso codice rc_. */
      var query = 'tag:"' + tag + '"';
      if (vendor) query += ' AND vendor:"' + vendor + '"';

      /* Chiave di cache VERSIONATA (cp2). La v1 conteneva i risultati
         della vecchia query sbagliata: senza cambiare prefisso, chi ha
         gia' la sessione aperta continuerebbe a vedere i conteggi
         errati. Il vendor entra nella chiave perche' ora fa parte
         della query. */
      var cacheKey = 'eyeoo-cp2:' + tag + ':' + vendor;
      var html = null;

      try { html = sessionStorage.getItem(cacheKey); } catch (e) {}

      if (!html) {
        var url = (this.dataset.searchUrl || '/search')
          + '?q=' + encodeURIComponent(query)
          + '&type=product'
          + '&section_id=' + encodeURIComponent(this.dataset.sectionId || 'eyeoo-color-picker-results');
        try {
          var res = await fetch(url, { headers: { Accept: 'text/html' } });
          if (!res.ok) return;
          html = await res.text();
          try { sessionStorage.setItem(cacheKey, html); } catch (e) {}
        } catch (e) {
          return;
        }
      }

      var doc = new DOMParser().parseFromString(html, 'text/html');
      var count = doc.querySelectorAll(CC_CONFIG.swatchSelector).length || 1;

      this.textContent = count === 1
        ? '1 ' + CC_CONFIG.labelSingular
        : count + ' ' + CC_CONFIG.labelPlural;
    }
  }

  window.customElements.define('eyeoo-card-colors', EyeooCardColors);
})();

/* ============================================================
   EYEOO – Modulo principale
   ============================================================ */
(function () {
  'use strict';

  // Namespace unico per evitare collisioni con il tema e le app
  window.EYEOO = window.EYEOO || {};

  /* Flag su <html>: l'elemento non viene mai rimpiazzato dai re-render
     AJAX, quindi il CSS puo' nascondere i nodi nativi sostituiti dal
     nostro markup senza dipendere da classi riapplicate a ogni render.
     Se il JS non parte, i nodi nativi restano visibili (degrado sicuro). */
  document.documentElement.classList.add('eyeoo-js');

  /* ----------------------------------------------------------
     CONFIG — tutti i valori tema-specifici vivono qui.
     ---------------------------------------------------------- */
  var CONFIG = {
    selectors: {
      facetsHorizontal: '.snippet-facets--horizontal',
      facetGroup: '.snippet-facets--horizontal accordion-block'
    },
    /* Remap etichette opzioni varianti (Shopify_option1 -> etichetta).
       Copre solo lo storefront; checkout/email vanno risolti alla fonte. */
    optionLabels: {
      map: {
        shopify_option1: 'Calibro' // TODO: etichetta definitiva
        // shopify_option2: '...'
      },
      scopes: [
        '.product-overview-section',
        'cart-drawer',               // TODO: verificare tag/classe reale
        'quick-add-modal'            // TODO: verificare tag/classe reale
      ]
    },
    /* Quick filters: pillole (Donna/Uomo, Sole/Vista) iniettate nella
       barra filtri delle collection thelios-plp. MODALITA' NAVIGAZIONE:
       ogni pillola porta alla collection dedicata, derivata dall'handle
       corrente secondo la convenzione:
         {brand}[-woman|-man][-sunglasses|-glasses]
       (es. celine, celine-woman, celine-man-sunglasses...)
       Il tipo (sunglasses/glasses) esiste solo sotto un genere: senza
       genere selezionato le pillole Sole/Vista sono disabilitate, e
       deselezionando il genere cade anche il tipo.
       Attivo SOLO se window.EYEOO_QUICKFILTERS === true (gate via Liquid
       in eyeoo-assets.liquid, per il solo template thelios-plp). */
    quickFilters: {
      gender: [
        { label: 'Donna', suffix: 'woman' },
        { label: 'Uomo', suffix: 'man' }
      ],
      type: [
        { label: 'Sole', suffix: 'sunglasses' },
        { label: 'Vista', suffix: 'glasses' }
      ],
      // elemento della barra dopo cui iniettare le pillole
      anchorSelector: 'facet-drawer.mobile-facets__wrapper'
    },
    /* Facet booleani (stile Ottica Spoto): i filtri Si'/No configurati
       qui vengono resi come toggle a scatto singolo — click sul chip
       (o sulla voce del drawer) = applica/togli il valore positivo,
       senza aprire il dropdown con Si'/No. Il valore positivo viene
       riconosciuto dall'ETICHETTA (i value sono GID dei gruppi S&D). */
    booleanFacets: {
      params: [
        'filter.p.m.custom.filter_photochromic',
        'filter.p.m.custom.filter_polarized',
        'filter.p.m.custom.filter_new_product'
      ],
      positiveLabels: ['si', 'sì', 'y', 'yes']
    },
    /* Guida taglie: NON sposta l'opener nativo (verrebbe distrutto dal
       re-render del variant picker al cambio taglia). Invece:
       - tiene l'opener nativo fermo nel suo blocco, nascosto via CSS;
       - inietta nell'etichetta taglie un proxy-link che clona icona+testo
         dell'opener nativo e, al click, fa scattare l'opener nativo;
       - un MutationObserver ri-inietta il proxy dopo i re-render AJAX.
       Il link compare solo se: popup nativo presente E opzione taglia
       presente sul prodotto. */
    sizeGuide: {
      // nome/i opzione (case-insensitive) considerati "taglia".
      // Match sull'attributo name del controllo, immune al remap testo.
      optionNames: ['shopify_option1'], // TODO: nome reale opzione taglia
      // testo del link del blocco Popup nativo: deve coincidere ESATTAMENTE
      // con il "Link text" impostato nel blocco Popup.
      openerText: 'Guida alle taglie'
    },
    /* Meta riga filtri: lettering del conteggio ed etichetta sort.
       countSelectors: candidati per il nodo conteggio nativo di Avante
       (orizzontale = .product-count__text, drawer = #ProductCount...). */
    facetsMeta: {
      countSelectors: '#ProductCount, #ProductCountDesktop, .product-count__text, .product-count, .products-count, .facets__count',
      countPrefix: 'Mostra',
      countJoin: 'di',
      countFallback: 'Risultati',
      sortLabel: 'Ordina per',
      /* Le voci del proxy vengono messe in maiuscolo lato JS: il
         text-transform CSS non copre il picker nativo su mobile. */
      uppercaseOptions: true,
      /* Rete di sicurezza: se dopo N ms l'URL non riflette
         l'ordinamento scelto, si naviga direttamente (0 = disattiva). */
      sortFallbackMs: 1500,
      /* Opzionale: etichette brevi per le voci del sort (le option del
         proxy sono nostre, il nativo non viene toccato). Chiave = value
         Shopify. Lasciare vuoto per usare i testi del tema. */
      sortLabels: {
        // 'manual': 'In evidenza',
        // 'created-descending': 'Dal più recente',
        // 'price-ascending': 'Prezzo crescente',
        // 'price-descending': 'Prezzo decrescente'
      }
    },
    /* Galleria PDP: frecce sulla striscia delle thumbnail.
       Avante rende i pulsanti solo sullo slider principale; qui li
       aggiungiamo alla striscia, pilotando lo scroll nativo del
       contenitore (nessun aggancio allo slider-component del tema). */
    galleryThumbs: {
      enabled: true,
      prevLabel: 'Immagini precedenti',
      nextLabel: 'Immagini successive',
      // quota di larghezza visibile per ogni click (0.8 = 80%)
      stepRatio: 0.8
    },
    /* Filtri disattivati per collection.
       La lista dei parametri arriva da Liquid in window.EYEOO_HIDDEN_FACETS
       (vedi snippets/eyeoo-assets.liquid), che legge i metafield:
         custom.disable_brand_from_filter -> filter.p.vendor
         custom.disable_type_filter       -> filter.p.product_type
         custom.disable_gender_filter     -> filter.p.m.filter.gender
       Qui il JS fa solo da rete di sicurezza sul CSS pre-paint:
       identifica i gruppi dal name degli input (sempre affidabile,
       a differenza degli id che dipendono dal template). */
    hiddenFacets: {
      // 'hide' = gruppo rimosso | 'disable' = visibile ma non cliccabile
      mode: 'hide'
    },
    /* PLP standard: il tema nasconde la barra orizzontale sotto i
       920px (.only-desktop) senza renderizzare un drawer mobile.
       forceHorizontal = true la tiene visibile anche su mobile.
       Metterlo a false se il tema iniziasse a fornire un drawer suo. */
    facetsMobile: {
      forceHorizontal: true
    },
    /* Chiusura automatica del pannello faccetta dopo una selezione
       (richiesta Aaron 28/07). Esclude i campi range del prezzo e i
       chip booleani, che non aprono pannelli. */
    autoClose: {
      enabled: true,
      // 'all' = anche nel drawer mobile; 'horizontal' = solo dropdown desktop
      scope: 'all'
    },
    debug: false
  };

  function log() {
    if (CONFIG.debug && window.console) {
      console.log.apply(console, ['[EYEOO]'].concat([].slice.call(arguments)));
    }
  }

  /* ----------------------------------------------------------
     OBSERVER CONDIVISO sui re-render AJAX dei facets.
     NB: definito PRIMA del lifecycle. Nella versione precedente
     EYEOO.observeFacets era assegnato DOPO la chiamata a init(),
     quindi con lo script in defer (readyState = 'interactive')
     l'observer non veniva mai registrato: dopo ogni filtro AJAX
     la barra non veniva reiniettata.
     Sottoscrittori multipli + debounce su requestAnimationFrame
     (un re-render genera decine di mutation).
     ---------------------------------------------------------- */
  var facetsObserver = (function () {
    var callbacks = [];
    var started = false;

    function start() {
      if (started || !window.MutationObserver) return;
      var target = document.getElementById('ProductGridContainer') ||
        document.querySelector('[id^="ProductGridContainer"]');
      if (!target) return;
      started = true;
      var rafId = null;
      new MutationObserver(function () {
        if (rafId) return;
        rafId = window.requestAnimationFrame(function () {
          rafId = null;
          log('facets re-render');
          callbacks.forEach(function (cb) {
            try { cb(); } catch (e) {
              if (window.console) console.error('[EYEOO] facets callback fallita:', e);
            }
          });
        });
      }).observe(target, { childList: true, subtree: true });
      log('facets observer attivo');
    }

    function on(cb) {
      if (typeof cb === 'function' && callbacks.indexOf(cb) === -1) callbacks.push(cb);
      start();
    }

    return { on: on, start: start };
  })();

  /* ----------------------------------------------------------
     MODULO: option labels
     ---------------------------------------------------------- */
  var optionLabels = (function () {
    var KEYS = Object.keys(CONFIG.optionLabels.map);
    var PATTERN = KEYS.length ? new RegExp('(' + KEYS.join('|') + ')', 'gi') : null;

    function relabel(root) {
      if (!root || !PATTERN) return;
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
      var node;
      while ((node = walker.nextNode())) {
        var value = node.nodeValue;
        if (!value) continue;
        var lower = value.toLowerCase();
        var hit = false;
        for (var i = 0; i < KEYS.length; i++) {
          if (lower.indexOf(KEYS[i]) !== -1) { hit = true; break; }
        }
        if (!hit) continue;
        node.nodeValue = value.replace(PATTERN, function (match) {
          return CONFIG.optionLabels.map[match.toLowerCase()] || match;
        });
        log('option label remapped in', root);
      }
    }

    function observe(scopeEl) {
      if (scopeEl.hasAttribute('data-eyeoo-labels-init')) return;
      scopeEl.setAttribute('data-eyeoo-labels-init', '');
      relabel(scopeEl);
      if (!window.MutationObserver) return;
      var rafId = null;
      new MutationObserver(function () {
        if (rafId) return;
        rafId = window.requestAnimationFrame(function () {
          rafId = null;
          relabel(scopeEl);
        });
      }).observe(scopeEl, { childList: true, subtree: true, characterData: true });
    }

    function setup(root) {
      if (!PATTERN) return;
      root = root || document;
      CONFIG.optionLabels.scopes.forEach(function (selector) {
        if (root !== document && root.matches && root.matches(selector)) {
          observe(root);
        }
        root.querySelectorAll(selector).forEach(observe);
      });
    }

    return { setup: setup, relabel: relabel };
  })();

  /* ----------------------------------------------------------
     MODULO: size guide
     ---------------------------------------------------------- */
  var sizeGuide = (function () {
    var observing = false;

    function optionNameOf(control) {
      var name = (control.getAttribute('name') || '').toLowerCase();
      return name.replace(/^options\[/, '').replace(/\]$/, '');
    }

    function findNativeOpener() {
      var target = (CONFIG.sizeGuide.openerText || '').trim().toLowerCase();
      if (!target) return null;
      var openers = document.querySelectorAll('modal-opener.product-popup-modal__opener');
      for (var i = 0; i < openers.length; i++) {
        var span = openers[i].querySelector('button span');
        if (span && span.textContent.trim().toLowerCase() === target) {
          return openers[i];
        }
      }
      return null;
    }

    // Apre il popup nativo facendo scattare l'opener (funziona anche se
    // l'opener e' display:none: click() dispatcha l'evento comunque).
    function trigger() {
      var opener = findNativeOpener();
      var btn = opener && opener.querySelector('button');
      if (btn) btn.click();
    }

    function place() {
      if (!CONFIG.sizeGuide.optionNames.length) return;

      var opener = findNativeOpener();
      if (!opener) return; // popup nativo non presente su questa PDP

      // Opener nativo: resta nel suo blocco, ma nascosto (via CSS).
      opener.classList.add('eyeoo-sg-opener');

      var groups = document.querySelectorAll('.product-form__input');
      for (var i = 0; i < groups.length; i++) {
        var group = groups[i];
        var control = group.querySelector('input[type="radio"][name]') ||
          group.querySelector('select[name]');
        if (!control) continue;
        if (CONFIG.sizeGuide.optionNames.indexOf(optionNameOf(control)) === -1) continue;

        var label = group.querySelector('.form__label');
        if (!label) continue;
        if (label.querySelector('.eyeoo-sg-link')) return; // gia' presente

        var link = document.createElement('button');
        link.type = 'button';
        link.className = 'eyeoo-sg-link';
        link.setAttribute('data-eyeoo-sg-open', '');
        // clona icona + testo dall'opener nativo per l'aspetto identico
        var srcBtn = opener.querySelector('button');
        link.innerHTML = srcBtn ? srcBtn.innerHTML : CONFIG.sizeGuide.openerText;

        label.appendChild(link);
        label.setAttribute('data-eyeoo-sg-injected', '');
        log('size guide proxy link injected');
        return;
      }
    }

    // Ri-inietta il proxy dopo i re-render AJAX del variant picker
    function observe() {
      if (observing || !window.MutationObserver) return;
      var section = document.querySelector('.product-overview-section');
      if (!section) return;
      observing = true;
      var rafId = null;
      new MutationObserver(function () {
        if (rafId) return;
        rafId = window.requestAnimationFrame(function () {
          rafId = null;
          place();
        });
      }).observe(section, { childList: true, subtree: true });
    }

    function inject() {
      place();
      observe();
    }

    return { inject: inject, trigger: trigger };
  })();

  /* ----------------------------------------------------------
     MODULO: facets meta — "Mostra X - Y di N | Ordina per [select]"
     Condiviso tra PLP Thelios (dentro la riga quick filters) e PLP
     standard (prima riga della barra filtri orizzontale).
     - il conteggio e' testo NOSTRO (numero letto dal nodo nativo,
       che viene nascosto): lettering sotto il nostro controllo;
     - il sort e' un PROXY: il select nativo resta dov'e' con i suoi
       listener, il proxy ne replica le opzioni e riporta il change
       dispatchando input+change (Avante/Dawn ascolta 'input').
     variant: '' (Thelios, allineato a destra) | 'bar' (PLP standard,
     conteggio a sinistra e sort a destra, riga con hairline sotto).
     ---------------------------------------------------------- */
  var facetsMeta = (function () {

    function build(variant) {
      var meta = document.createElement('div');
      // label--custom uppercase = stesse metriche font delle etichette
      // native del tema (conteggio prodotti, "Ordina per:")
      meta.className = 'eyeoo-qf__meta label--custom uppercase' +
        (variant ? ' eyeoo-qf__meta--' + variant : '');

      var count = document.createElement('span');
      count.className = 'eyeoo-qf__count';
      meta.appendChild(count);

      var sep = document.createElement('span');
      sep.className = 'eyeoo-qf__sep';
      sep.setAttribute('aria-hidden', 'true');
      sep.textContent = '|';
      meta.appendChild(sep);

      // label + select in un wrapper: su mobile diventa una cella unica
      // (etichetta sovrapposta al select, stile eye-oo)
      var sortWrap = document.createElement('span');
      sortWrap.className = 'eyeoo-qf__sortwrap';

      var lbl = document.createElement('label');
      lbl.className = 'eyeoo-qf__sortlabel';
      lbl.textContent = CONFIG.facetsMeta.sortLabel;
      sortWrap.appendChild(lbl);

      meta.appendChild(sortWrap);

      return meta;
    }

    /* "Mostra 1 - 24 di 645" — totale dal nodo nativo, quanti sono in
       pagina contandoli in griglia, pagina corrente dall'URL. */
    function refreshCount(meta) {
      var nativeCount = document.querySelector(CONFIG.facetsMeta.countSelectors);
      var target = meta.querySelector('.eyeoo-qf__count');
      if (!nativeCount || !target) return;

      var m = (nativeCount.textContent || '')
        .replace(/[.,](?=\d{3})/g, '').match(/\d+/);
      var total = m ? parseInt(m[0], 10) : 0;

      var gridScope = document.querySelector('[id^="ProductGridContainer"]') || document;
      var shown = gridScope.querySelectorAll('.card-container').length;

      var page = parseInt(
        new URL(window.location.href).searchParams.get('page') || '1', 10
      );

      var hasNext = !!document.querySelector(
        '.pagination a[aria-label*="uccessiv"], .pagination__item--next, a[rel="next"]'
      );

      var start, end;
      if (hasNext || page === 1) {
        start = (page - 1) * shown + 1;
        end = page * shown;
      } else {
        end = total;
        start = total - shown + 1;
      }

      if (total && shown) {
        target.textContent = CONFIG.facetsMeta.countPrefix + ' ' + start +
          ' - ' + Math.min(end, total) + ' ' + CONFIG.facetsMeta.countJoin + ' ' + total;
      } else if (total) {
        target.textContent = total + ' ' + CONFIG.facetsMeta.countFallback;
      }

      /* Nasconde TUTTI i nodi conteggio nativi, non solo il primo:
         Avante ne renderizza piu' di uno (desktop + varianti mobile) e
         nascondendo solo il primo restava visibile quello a schermo. */
      var all = document.querySelectorAll(CONFIG.facetsMeta.countSelectors);
      for (var c = 0; c < all.length; c++) {
        var home = all[c].closest('.product-count') || all[c];
        home.classList.add('eyeoo-qf-native-hidden');
        /* Il tema avvolge il conteggio in un <div> senza classe che resta
           un flex item vuoto (e quindi porta con se' il gap della riga):
           se il wrapper non contiene altro, si nasconde anche quello. */
        var box = home.closest('.active-facets') || home;
        var outer = box.parentElement;
        if (outer && !outer.className && outer.children.length === 1) {
          outer.classList.add('eyeoo-qf-native-hidden');
        } else if (box !== home) {
          box.classList.add('eyeoo-qf-native-hidden');
        }
      }
    }

    /* Tutti i select sort nativi (Avante ne renderizza piu' di uno:
       desktop + variante mobile). Vanno allineati TUTTI: se ne resta
       uno col valore vecchio, la FormData del tema invia quello e
       l'ordinamento "torna indietro" dopo il re-render. */
    function nativeSorts() {
      return document.querySelectorAll('select[name="sort_by"]:not(.eyeoo-qf__sort)');
    }

    function urlSort() {
      return new URL(window.location.href).searchParams.get('sort_by');
    }

    function requestSort(value) {
      var natives = nativeSorts();
      var i;
      for (i = 0; i < natives.length; i++) natives[i].value = value;
      // dispatch dopo aver allineato tutti, altrimenti il primo submit
      // parte con gli altri select ancora sul valore precedente
      for (i = 0; i < natives.length; i++) {
        natives[i].dispatchEvent(new Event('input', { bubbles: true }));
        natives[i].dispatchEvent(new Event('change', { bubbles: true }));
      }
      log('sort richiesto', value, 'su', natives.length, 'select nativi');

      // Rete di sicurezza: se l'AJAX del tema non ha applicato il sort
      // (URL non aggiornato), si naviga. Se ha funzionato, non fa nulla.
      var ms = CONFIG.facetsMeta.sortFallbackMs;
      if (!ms) return;
      window.setTimeout(function () {
        if (urlSort() === value) return;
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', value);
        url.searchParams.delete('page');
        log('sort AJAX non applicato: fallback su navigazione');
        window.location.href = url.toString();
      }, ms);
    }

    function syncSort(meta) {
      var natives = nativeSorts();
      if (!natives.length) return;
      var nativeSort = natives[0];

      var proxy = meta.querySelector('select.eyeoo-qf__sort');
      if (!proxy) {
        proxy = document.createElement('select');
        proxy.className = 'eyeoo-qf__sort label--custom uppercase';
        proxy.id = 'eyeoo-qf-sort';
        proxy.setAttribute('aria-label', CONFIG.facetsMeta.sortLabel);
        var lbl = meta.querySelector('.eyeoo-qf__sortlabel');
        if (lbl) lbl.setAttribute('for', proxy.id);
        proxy.addEventListener('change', function () {
          requestSort(proxy.value);
        });
        (meta.querySelector('.eyeoo-qf__sortwrap') || meta).appendChild(proxy);
      }

      // (ri)allinea opzioni e valore al nativo, anche dopo i re-render
      if (proxy.options.length !== nativeSort.options.length) {
        proxy.innerHTML = '';
        for (var i = 0; i < nativeSort.options.length; i++) {
          var opt = document.createElement('option');
          opt.value = nativeSort.options[i].value;
          var text = CONFIG.facetsMeta.sortLabels[nativeSort.options[i].value] ||
            nativeSort.options[i].textContent.trim();
          opt.textContent = CONFIG.facetsMeta.uppercaseOptions ? text.toUpperCase() : text;
          proxy.appendChild(opt);
        }
      }
      // l'URL e' la fonte di verita' (il tema aggiorna la history):
      // evita che il proxy "torni indietro" se un select nativo lagga
      proxy.value = urlSort() || nativeSort.value;
    }

    /* Nasconde il contenitore del sort nativo. NON usa mai wrapper
       generici (.facets__wrapper) per non portarsi via altri nodi. */
    function hideNativeSort() {
      var natives = nativeSorts();
      for (var i = 0; i < natives.length; i++) {
        var home = natives[i].closest('.sorting') ||
          natives[i].closest('.mobile-facets__sort') ||
          natives[i].closest('.facet-sorting') ||
          natives[i].closest('.facet-filters__field') ||
          natives[i].parentElement;
        if (home && !home.querySelector('.eyeoo-qf__meta')) {
          home.classList.add('eyeoo-qf-native-hidden');
        }
      }
    }

    /* Idempotente: riusa il meta esistente nella riga (contiene il
       proxy, non va distrutto) e ne aggiorna solo i valori. */
    function inject(row, variant) {
      if (!row) return null;
      var meta = row.querySelector('.eyeoo-qf__meta');
      if (!meta) meta = build(variant);
      refreshCount(meta);
      syncSort(meta);
      if (!meta.parentNode) row.appendChild(meta);
      return meta;
    }

    return { inject: inject, hideNativeSort: hideNativeSort, requestSort: requestSort };
  })();

  /* ----------------------------------------------------------
     MODULO: quick filters
     Inietta pillole filtro rapido (es. Donna/Uomo, Sole/Vista)
     accanto al bottone filtri della collection. Ogni pillola
     alterna il proprio valore facet nell'URL: dentro un gruppo
     vale la selezione singola (Donna sostituisce Uomo), il click
     sulla pillola attiva rimuove il filtro. Gli altri parametri
     (filtri, sort) vengono preservati; la paginazione si resetta.
     Gate: window.EYEOO_QUICKFILTERS (impostato via Liquid solo
     sul template desiderato).
     ---------------------------------------------------------- */
  var quickFilters = (function () {
    var observing = false;
    var GENDER = null; // suffissi ammessi, letti da CONFIG
    var TYPE = null;

    function suffixes(list) {
      return list.map(function (o) { return o.suffix; });
    }

    /* Scompone l'handle corrente secondo la convenzione
       {brand}[-woman|-man][-sunglasses|-glasses] */
    function parseHandle(handle) {
      var state = { base: handle, gender: null, type: null };
      var i;
      for (i = 0; i < TYPE.length; i++) {
        var ts = '-' + TYPE[i];
        if (state.base.slice(-ts.length) === ts) {
          state.type = TYPE[i];
          state.base = state.base.slice(0, -ts.length);
          break;
        }
      }
      for (i = 0; i < GENDER.length; i++) {
        var gs = '-' + GENDER[i];
        if (state.base.slice(-gs.length) === gs) {
          state.gender = GENDER[i];
          state.base = state.base.slice(0, -gs.length);
          break;
        }
      }
      return state;
    }

    function currentState() {
      var m = window.location.pathname.match(/\/collections\/([^\/]+)/);
      if (!m) return null;
      return parseHandle(m[1]);
    }

    function buildHandle(base, gender, type) {
      var h = base;
      if (gender) h += '-' + gender;
      if (gender && type) h += '-' + type; // il tipo esiste solo sotto un genere
      return h;
    }

    function buildUrl(handle) {
      var url = '/collections/' + handle;
      // preserva solo l'ordinamento; i filtri facet non sono trasferibili
      var sort = new URL(window.location.href).searchParams.get('sort_by');
      if (sort) url += '?sort_by=' + encodeURIComponent(sort);
      return url;
    }

    function makePill(label, href, active, disabled) {
      var a = document.createElement('a');
      a.className = 'eyeoo-qf__pill';
      a.textContent = label;
      if (disabled) {
        a.classList.add('is-disabled');
        a.setAttribute('aria-disabled', 'true');
        a.setAttribute('tabindex', '-1');
      } else {
        a.href = href;
      }
      if (active) {
        a.classList.add('is-active');
        a.setAttribute('aria-pressed', 'true');
      }
      return a;
    }

    function build(state) {
      var wrap = document.createElement('div');
      // body-text--custom: eredita font del tema (Avante non ha font globale)
      wrap.className = 'eyeoo-qf body-text--custom';

      // Gruppo genere: click su attiva = deseleziona (cade anche il tipo)
      var gGroup = document.createElement('div');
      gGroup.className = 'eyeoo-qf__group';
      CONFIG.quickFilters.gender.forEach(function (opt) {
        var active = state.gender === opt.suffix;
        var target = active
          ? buildHandle(state.base, null, null)
          : buildHandle(state.base, opt.suffix, state.type);
        gGroup.appendChild(makePill(opt.label, buildUrl(target), active, false));
      });
      wrap.appendChild(gGroup);

      // Gruppo tipo: compare SOLO quando un genere e' selezionato
      if (state.gender) {
        var tGroup = document.createElement('div');
        tGroup.className = 'eyeoo-qf__group';
        CONFIG.quickFilters.type.forEach(function (opt) {
          var active = state.type === opt.suffix;
          var target = active
            ? buildHandle(state.base, state.gender, null)
            : buildHandle(state.base, state.gender, opt.suffix);
          tGroup.appendChild(makePill(opt.label, buildUrl(target), active, false));
        });
        wrap.appendChild(tGroup);
      }

      return wrap;
    }

    function inject() {
      if (!window.EYEOO_QUICKFILTERS) return;
      GENDER = GENDER || suffixes(CONFIG.quickFilters.gender);
      TYPE = TYPE || suffixes(CONFIG.quickFilters.type);

      var state = currentState();
      if (!state) return; // non siamo su una collection

      var anchor = document.querySelector(CONFIG.quickFilters.anchorSelector);
      if (!anchor || !anchor.parentNode) return;

      // Rimuovi e ricostruisci (idempotente anche dopo i re-render facets)
      var existing = document.querySelector('.eyeoo-qf');
      if (existing) existing.remove();

      var wrap = build(state);

      // Allinea in altezza le pillole al bottone filtri (misura reale)
      var filterBtn = anchor.querySelector('button');
      if (filterBtn && filterBtn.offsetHeight) {
        wrap.style.setProperty('--eyeoo-qf-h', filterBtn.offsetHeight + 'px');
      }

      // La barra del tema non e' flex: la marchiamo con una classe nostra
      // (solo classList, nessun file vendor toccato) per metterla in riga
      anchor.parentNode.classList.add('eyeoo-qf-row');

      anchor.parentNode.insertBefore(wrap, anchor.nextSibling);
      facetsMeta.inject(anchor.parentNode);
      log('quick filters injected', state);

      // I re-render AJAX dei facets possono spazzare la barra: reinietta
      if (!observing) {
        observing = true;
        facetsObserver.on(function () { inject(); });
      }
    }

    return { inject: inject };
  })();

  /* ----------------------------------------------------------
     MODULO: boolean facets
     Trasforma i facet Si'/No configurati in toggle a scatto singolo
     (replica dell'hack di Minimalista su Spoto, ma senza edit vendor).
     Il gruppo viene marcato con .eyeoo-bf (il CSS nasconde il pannello
     dropdown); il click sul summary viene intercettato in capture e
     alterna il checkbox positivo pilotando il form nativo (AJAX tema).
     Stato attivo: classe .eyeoo-bf--active sul gruppo.
     ---------------------------------------------------------- */
  var booleanFacets = (function () {
    function normalizeLabel(text) {
      return (text || '').replace(/\(\d+\)/g, '').trim().toLowerCase();
    }

    function isPositive(input) {
      // prova l'etichetta visibile associata all'input
      var label = input.closest('label') ||
        (input.id && document.querySelector('label[for="' + CSS.escape(input.id) + '"]'));
      var text = label ? label.textContent : input.value;
      var norm = normalizeLabel(text);
      // il value grezzo (Y) vale come fallback quando non e' un GID
      var val = (input.value || '').toLowerCase();
      return CONFIG.booleanFacets.positiveLabels.indexOf(norm) !== -1 ||
        CONFIG.booleanFacets.positiveLabels.indexOf(val) !== -1;
    }

    function groupOf(input) {
      return input.closest('accordion-block') ||
        input.closest('.js-filter') ||
        input.closest('details');
    }

    function positiveInputOf(group, param) {
      var inputs = group.querySelectorAll('input[name="' + param + '"]');
      for (var i = 0; i < inputs.length; i++) {
        if (isPositive(inputs[i])) return inputs[i];
      }
      return null;
    }

    function refreshState(group, positive) {
      group.classList.toggle('eyeoo-bf--active', !!positive.checked);
    }

    function setup(root) {
      root = root || document;
      CONFIG.booleanFacets.params.forEach(function (param) {
        var inputs = (root.querySelectorAll ? root : document)
          .querySelectorAll('input[name="' + param + '"]');
        var seen = [];
        for (var i = 0; i < inputs.length; i++) {
          var group = groupOf(inputs[i]);
          if (!group || seen.indexOf(group) !== -1) continue;
          seen.push(group);
          var positive = positiveInputOf(group, param);
          if (!positive) {
            // Solo valori negativi (nessun prodotto ha la caratteristica):
            // il filtro e' inutile, nascondi l'intero gruppo.
            var block = group.closest('accordion-block') || group;
            block.classList.add('eyeoo-bf-hidden');
            continue;
          }
          group.classList.add('eyeoo-bf');
          group.setAttribute('data-eyeoo-bf-param', param);
          refreshState(group, positive);
        }
      });
    }

    function toggle(group) {
      var param = group.getAttribute('data-eyeoo-bf-param');
      if (!param) return;
      var positive = positiveInputOf(group, param);
      if (!positive) return;

      var wasChecked = positive.checked;
      // azzera tutti i valori del facet (incluso l'eventuale "No")
      group.querySelectorAll('input[name="' + param + '"]').forEach(function (inp) {
        inp.checked = false;
      });
      positive.checked = !wasChecked;
      refreshState(group, positive);
      // Avante/Dawn ascolta 'input' sul form dei facets: con il solo
      // 'change' il toggle cambiava stato ma NON applicava il filtro.
      positive.dispatchEvent(new Event('input', { bubbles: true }));
      positive.dispatchEvent(new Event('change', { bubbles: true }));
      log('boolean facet toggled', param, positive.checked);
    }

    /* Pill "filtri attivi": Shopify stampa "Nuovi arrivi: Y".
       Per i facet booleani il valore non aggiunge informazione:
       si tiene solo il nome del filtro (richiesta Aaron 28/07). */
    function cleanActiveLabels(root) {
      root = root || document;
      var buttons = root.querySelectorAll('.active-facets__button, .active-facets__button-inner');
      for (var i = 0; i < buttons.length; i++) {
        var btn = buttons[i];
        var txt = btn.textContent || '';
        var parts = txt.split(':');
        if (parts.length < 2) continue;
        var value = normalizeLabel(parts[parts.length - 1]);
        if (CONFIG.booleanFacets.positiveLabels.indexOf(value) === -1) continue;
        // riscrive SOLO il nodo di testo che contiene i due punti,
        // per non toccare l'icona di rimozione interna al bottone
        var walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT, null);
        var node;
        while ((node = walker.nextNode())) {
          if ((node.nodeValue || '').indexOf(':') === -1) continue;
          node.nodeValue = node.nodeValue.replace(/\s*:\s*[^:]*$/, '');
          break;
        }
      }
    }

    return { setup: setup, toggle: toggle, cleanActiveLabels: cleanActiveLabels };
  })();

  /* ----------------------------------------------------------
     MODULO: standard bar (PLP non-Thelios)
     Nuova disposizione richiesta il 28/07:
       riga 1  "Mostra 1 - 24 di 645"        [Ordina per ▾]
       ------------------------------------------------- hairline
       riga 2  [chip] [chip] [chip] ...
     Nessun nodo spostato: il meta viene APPESO alla barra e il CSS
     lo porta in prima riga (order: -1). Conteggio e sort nativi
     vengono nascosti (il proxy pilota il select nativo).
     ---------------------------------------------------------- */
  var standardBar = (function () {
    var observing = false;

    function inject() {
      // la barra orizzontale e' l'unica marcata --horizontal
      var bar = document.querySelector('.snippet-facets--horizontal .mobile-facets__inner');
      if (!bar) return;

      bar.classList.add('eyeoo-facets-bar');
      facetsMeta.inject(bar, 'bar');
      facetsMeta.hideNativeSort();

      if (!observing) {
        observing = true;
        facetsObserver.on(function () { inject(); });
      }
      log('standard bar injected');
    }

    return { inject: inject };
  })();

  /* ----------------------------------------------------------
     MODULO: facets mobile
     Sulla PLP standard il tema marca la barra orizzontale come
     .only-desktop: se NON esiste una variante mobile (drawer) la
     pagina resta senza filtri (segnalato da Francesca il 28/07).
     Qui rileviamo il caso e attiviamo il fallback: la stessa barra
     orizzontale resta visibile su mobile, con i chip a scorrimento
     (il layout mobile vive in eyeoo-facets.css).
     Il rilevamento e' auto-disabilitante: se il tema/tema aggiornato
     inizia a renderizzare un drawer mobile, la classe non viene messa.
     ---------------------------------------------------------- */
  /* ----------------------------------------------------------
     MODULO: gallery thumbs
     Frecce prev/next sulla striscia delle miniature della PDP.
     Non si aggancia allo slider-component del tema (il suo JS ha
     gia' fatto la query dei pulsanti alla costruzione): pilota
     direttamente lo scroll del contenitore, quindi resta additivo.
     Le frecce compaiono solo se c'e' overflow.
     ---------------------------------------------------------- */
  var galleryThumbs = (function () {

    /* Il contenitore scrollabile puo' essere la <ul> o il viewport,
       dipende dal layout scelto nella sezione: si rileva. */
    function scrollerOf(slider) {
      var candidates = [
        slider.querySelector('.thumbnail-list'),
        slider.querySelector('.slider__viewport')
      ];
      for (var i = 0; i < candidates.length; i++) {
        var el = candidates[i];
        if (!el) continue;
        var ox = window.getComputedStyle(el).overflowX;
        if (ox === 'auto' || ox === 'scroll') return el;
      }
      return candidates[0] || null;
    }

    function makeButton(dir, label) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'eyeoo-thumbs__nav eyeoo-thumbs__nav--' + dir;
      b.setAttribute('aria-label', label);
      b.innerHTML = '<svg aria-hidden="true" focusable="false" width="8" height="14" ' +
        'viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="' + (dir === 'prev' ? 'M7 1L1 7l6 6' : 'M1 1l6 6-6 6') +
        '" stroke="currentColor" stroke-width="1.2" fill="none"/></svg>';
      return b;
    }

    /* Stato "corrente" gestito da noi, non dedotto dalle classi del
       tema: la sorgente di verita' e' la slide attiva della galleria
       principale (data-media-id) confrontata col data-target della
       miniatura. Immune a cosa fa il tema con is-active/aria-current
       (autoplay, cambio variante, re-render). */
    function mainListOf(slider) {
      var gallery = slider.closest('media-gallery');
      return gallery ? gallery.querySelector('.product__media-list') : null;
    }

    /* Indicatore come ELEMENTO REALE, non pseudo-elemento: il tema usa
       un ::after sullo stesso <li> per la sua cornice, e su quel
       terreno la nostra regola era esposta a conflitti. Un <span>
       nostro non e' sovrascrivibile da regole del tema. */
    function ensureBar(li) {
      /* La barra va DENTRO il bottone (.thumbnail, che il tema rende
         position: relative): il <li> ha altezza e overflow gestiti dal
         JS dello slider, quindi tutto cio' che sta ai suoi margini
         rischia di essere ritagliato. Dentro il bottone siamo sempre
         nell'area visibile. Fallback sul <li> se il bottone manca. */
      var host = li.querySelector('.thumbnail') || li;
      var bar = host.querySelector('.eyeoo-thumb-bar');
      if (bar) return;
      var stale = li.querySelector('.eyeoo-thumb-bar');
      if (stale) stale.remove();
      bar = document.createElement('span');
      bar.className = 'eyeoo-thumb-bar';
      bar.setAttribute('aria-hidden', 'true');
      host.appendChild(bar);
    }

    function syncCurrent(slider) {
      var thumbs = slider.querySelectorAll('.thumbnail-list__item');
      if (!thumbs.length) return;

      var targetId = null;
      var main = mainListOf(slider);
      if (main) {
        var active = main.querySelector('.product__media-item.is-active');
        if (active) targetId = active.getAttribute('data-media-id');
      }

      var matched = null;
      for (var i = 0; i < thumbs.length; i++) {
        var li = thumbs[i];
        ensureBar(li);
        var isCurrent = targetId
          ? li.getAttribute('data-target') === targetId
          : (li.classList.contains('is-active') ||
             !!li.querySelector('.thumbnail[aria-current="true"]'));
        li.classList.toggle('eyeoo-thumb-current', isCurrent);
        if (isCurrent) matched = li;
      }
      // nessuna corrispondenza: la prima resta comunque marcata
      if (!matched) thumbs[0].classList.add('eyeoo-thumb-current');
    }

    function watchCurrent(slider) {
      var rafId = null;
      function schedule() {
        if (rafId) return;
        rafId = window.requestAnimationFrame(function () {
          rafId = null;
          syncCurrent(slider);
        });
      }

      var main = mainListOf(slider);
      if (main && window.MutationObserver) {
        new MutationObserver(schedule).observe(main, {
          attributes: true, attributeFilter: ['class'], subtree: true
        });
      }
      // click su una miniatura: allineamento immediato
      slider.addEventListener('click', schedule);
      syncCurrent(slider);
    }

    function refresh(slider, scroller) {
      var overflow = scroller.scrollWidth - scroller.clientWidth > 2;
      slider.classList.toggle('eyeoo-thumbs--overflow', overflow);
      if (!overflow) return;
      var max = scroller.scrollWidth - scroller.clientWidth;
      slider.classList.toggle('is-start', scroller.scrollLeft <= 1);
      slider.classList.toggle('is-end', scroller.scrollLeft >= max - 1);
    }

    function setup() {
      if (!CONFIG.galleryThumbs.enabled) return;
      var sliders = document.querySelectorAll('slider-component.thumbnail-slider');

      for (var i = 0; i < sliders.length; i++) {
        var slider = sliders[i];
        if (slider.hasAttribute('data-eyeoo-thumbs')) continue;

        var scroller = scrollerOf(slider);
        if (!scroller) continue;

        slider.setAttribute('data-eyeoo-thumbs', '');
        slider.classList.add('eyeoo-thumbs');

        var prev = makeButton('prev', CONFIG.galleryThumbs.prevLabel);
        var next = makeButton('next', CONFIG.galleryThumbs.nextLabel);
        slider.appendChild(prev);
        slider.appendChild(next);

        (function (slider, scroller, prev, next) {
          function step() {
            var w = scroller.clientWidth * CONFIG.galleryThumbs.stepRatio;
            var item = scroller.querySelector('.thumbnail-list__item');
            return Math.max(w, item ? item.offsetWidth : 80);
          }
          function go(sign) {
            /* lo scorrimento e' animato dal browser; con
               prefers-reduced-motion si passa allo salto secco */
            var reduce = window.matchMedia &&
              window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            scroller.scrollBy({
              left: sign * step(),
              behavior: reduce ? 'auto' : 'smooth'
            });
          }
          /* .is-pressed fa partire l'animazione completa del bottone:
             con il solo :active durava quanto il click e non si vedeva */
          function press(btn) {
            btn.classList.remove('is-pressed');
            // reflow forzato: riavvia l'animazione anche su click rapidi
            void btn.offsetWidth;
            btn.classList.add('is-pressed');
            window.setTimeout(function () {
              btn.classList.remove('is-pressed');
            }, 300);
          }

          prev.addEventListener('click', function () { press(prev); go(-1); });
          next.addEventListener('click', function () { press(next); go(1); });

          var rafId = null;
          function schedule() {
            if (rafId) return;
            rafId = window.requestAnimationFrame(function () {
              rafId = null;
              refresh(slider, scroller);
            });
          }
          scroller.addEventListener('scroll', schedule, { passive: true });
          window.addEventListener('resize', schedule);
          if (window.ResizeObserver) {
            new ResizeObserver(schedule).observe(scroller);
          }
          refresh(slider, scroller);
        })(slider, scroller, prev, next);

        watchCurrent(slider);

        log('gallery thumbs nav aggiunta');
      }
    }

    return { setup: setup };
  })();

  /* ----------------------------------------------------------
     MODULO: hidden facets
     Disattiva i filtri ridondanti sulla collection corrente (es. il
     filtro Brand dentro la pagina di un brand). Sorgente: metafield
     di collection letti in Liquid -> window.EYEOO_HIDDEN_FACETS.
     ---------------------------------------------------------- */
  var hiddenFacets = (function () {
    function list() {
      var l = window.EYEOO_HIDDEN_FACETS;
      return (l && l.length) ? l : [];
    }

    function groupOf(el) {
      return el.closest('accordion-block') ||
        el.closest('.js-filter') ||
        el.closest('details');
    }

    function apply() {
      var params = list();
      if (!params.length) return;
      var cls = CONFIG.hiddenFacets.mode === 'disable'
        ? 'eyeoo-facet-disabled'
        : 'eyeoo-facet-off';

      params.forEach(function (param) {
        var nodes = document.querySelectorAll('[name="' + param + '"]');
        for (var i = 0; i < nodes.length; i++) {
          var group = groupOf(nodes[i]);
          if (group) group.classList.add(cls);
        }
      });
      log('facet disattivati', params, '->', cls);
    }

    return { apply: apply };
  })();

  var facetsMobile = (function () {
    function apply() {
      var horiz = document.querySelector('.snippet-facets--horizontal');
      if (!horiz) return;

      var container = horiz.closest('[id^="main-collection-filters"]') || horiz.parentElement;
      if (!container) return;

      /* L'un-hide su mobile e' fatto in CSS (.eyeoo-js + max-width 920px,
         stesso breakpoint della regola del tema su .only-desktop).
         Qui si gestisce solo il kill-switch, se un giorno il tema
         iniziasse a renderizzare un suo drawer mobile. */
      container.classList.toggle('eyeoo-facets--mobile-off',
        !CONFIG.facetsMobile.forceHorizontal);

      if (CONFIG.debug) {
        var alt = document.querySelectorAll('.snippet-facets:not(.snippet-facets--horizontal)');
        log('facets mobile: forceHorizontal =', CONFIG.facetsMobile.forceHorizontal,
          '| altri snippet-facets trovati:', alt.length);
      }
    }

    return { apply: apply };
  })();

  /* ----------------------------------------------------------
     MODULO: facet auto close
     Alla selezione di un checkbox/radio di faccetta il pannello si
     chiude subito (richiesta Aaron 28/07). Il click sul summary e'
     preferito alla rimozione dell'attributo perche' lascia al tema
     animazione e stati aria; la rimozione resta come fallback.
     Il re-render AJAX puo' ripristinare lo stato aperto: l'indice
     del gruppo viene ricordato e richiuso dopo il render.
     ---------------------------------------------------------- */
  var facetAutoClose = (function () {
    var pendingIndex = null;
    var observing = false;

    /* Avante NON usa l'attributo [open] sugli accordion-block dei facet
       (verificato sul markup reale): lo stato aperto e' gestito dal tema
       con classi/altezze che non conosciamo. Il test e' quindi agnostico:
       il pannello e' aperto se occupa spazio. */
    function isOpen(block) {
      if (!block) return false;
      if (block.hasAttribute('open')) return true;
      var panel = block.querySelector('.accordion__panel');
      if (!panel) return false;
      return panel.offsetHeight > 0 &&
        window.getComputedStyle(panel).visibility !== 'hidden';
    }

    /* Chiude facendo scattare il summary: il toggle e' quello del tema,
       quindi animazione, icone +/- e stati aria restano coerenti. */
    function toggleClose(block) {
      var summary = block.querySelector('.accordion__summary, .mobile-facets__summary');
      if (summary) {
        summary.click();
      } else if (block.hasAttribute('open')) {
        block.removeAttribute('open');
      }
    }

    function closeIfOpen(block) {
      if (isOpen(block)) toggleClose(block);
    }

    function onChange(e) {
      if (!CONFIG.autoClose.enabled) return;
      var input = e.target;
      if (!input || !input.name || input.name.indexOf('filter.') !== 0) return;

      var type = (input.type || '').toLowerCase();
      if (type !== 'checkbox' && type !== 'radio') return; // esclude i range prezzo

      var block = input.closest('accordion-block');
      if (!block) return;
      if (block.classList.contains('eyeoo-bf')) return; // i booleani non hanno pannello

      if (CONFIG.autoClose.scope === 'horizontal' &&
        !block.closest('.snippet-facets--horizontal')) return;

      pendingIndex = block.getAttribute('data-index');

      /* Qui il pannello e' aperto per definizione (l'utente ha appena
         cliccato un checkbox al suo interno): si chiude senza test. */
      toggleClose(block);
      log('facet panel chiuso', pendingIndex);
    }

    /* Il re-render AJAX rigenera i facet e puo' ripristinare lo stato
       aperto: si richiude il gruppo su cui si era agito. */
    function afterRender() {
      if (!pendingIndex) return;
      var index = pendingIndex;
      pendingIndex = null;
      var block = document.querySelector('accordion-block[data-index="' + index + '"]');
      closeIfOpen(block);
    }

    function setup() {
      if (observing) return;
      observing = true;
      document.addEventListener('change', onChange);
      facetsObserver.on(afterRender);
    }

    return { setup: setup, isOpen: isOpen };
  })();

  /* ----------------------------------------------------------
     init() — punto di ingresso unico. IDEMPOTENTE.
     Ogni step e' isolato in try/catch: un modulo che fallisce
     non deve mai bloccare gli altri (ne' l'esecuzione del file).
     ---------------------------------------------------------- */
  function init(root) {
    root = root || document;
    log('init', root);

    [
      ['optionLabels', function () { optionLabels.setup(root); }],
      ['sizeGuide', function () { sizeGuide.inject(); }],
      ['facetsMobile', function () { facetsMobile.apply(); }],
      ['hiddenFacets', function () { hiddenFacets.apply(); }],
      ['quickFilters', function () { quickFilters.inject(); }],
      ['standardBar', function () { standardBar.inject(); }],
      ['booleanFacets', function () { booleanFacets.setup(root); }],
      ['activeLabels', function () { booleanFacets.cleanActiveLabels(root); }],
      ['facetAutoClose', function () { facetAutoClose.setup(); }],
      ['galleryThumbs', function () { galleryThumbs.setup(); }]
    ].forEach(function (step) {
      try {
        step[1]();
      } catch (e) {
        if (window.console) console.error('[EYEOO] init step "' + step[0] + '" fallito:', e);
      }
    });
  }

  /* ----------------------------------------------------------
     Lifecycle
     ---------------------------------------------------------- */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  // Click sul proxy-link guida taglie => apre il popup nativo
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-eyeoo-sg-open]')) {
      e.preventDefault();
      e.stopPropagation();
      sizeGuide.trigger();
    }
  });

  // Facet booleani: intercetta il click sul summary PRIMA che il tema
  // apra l'accordion, e alterna il toggle (capture: true e' essenziale)
  document.addEventListener('click', function (e) {
    var group = e.target.closest('.eyeoo-bf');
    if (!group) return;
    // non intercettare click su input/label interni (non visibili, ma per sicurezza)
    e.preventDefault();
    e.stopPropagation();
    booleanFacets.toggle(group);
  }, true);

  // Pillole quick filter disabilitate: nessuna azione
  document.addEventListener('click', function (e) {
    var pill = e.target.closest('.eyeoo-qf__pill.is-disabled');
    if (pill) e.preventDefault();
  });

  // Sort nativo (drawer) cambiato dall'utente => riallinea il proxy
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.name !== 'sort_by') return;
    if (t.classList.contains('eyeoo-qf__sort')) return; // e' il proxy stesso
    var proxy = document.querySelector('select.eyeoo-qf__sort');
    if (proxy && proxy.value !== t.value) proxy.value = t.value;
  });

  // Compat: la vecchia API delega all'observer condiviso
  EYEOO.observeFacets = function (callback) {
    facetsObserver.on(callback || function () { init(); });
  };

  // Dopo ogni re-render AJAX: riallinea meta, chip booleani ed etichette
  facetsObserver.on(function () {
    try { booleanFacets.setup(document); } catch (e) {}
    try { booleanFacets.cleanActiveLabels(document); } catch (e) {}
    try { facetsMobile.apply(); } catch (e) {}
    try { hiddenFacets.apply(); } catch (e) {}
  });

  // API pubblica minima
  EYEOO.init = init;
  EYEOO.config = CONFIG;
  EYEOO.quickFilters = quickFilters;
  EYEOO.standardBar = standardBar;
  EYEOO.facetsMeta = facetsMeta;
  EYEOO.facetsMobile = facetsMobile;
  EYEOO.hiddenFacets = hiddenFacets;
  EYEOO.galleryThumbs = galleryThumbs;
  EYEOO.facetAutoClose = facetAutoClose;
  EYEOO.optionLabels = optionLabels;
  EYEOO.sizeGuide = sizeGuide;
  EYEOO.booleanFacets = booleanFacets;
})();



// Banner gallery: il tema scrive sizes dividendo per 5 colonne. Se il
  // numero di colonne cambia, il browser scarica un candidato troppo
  // piccolo. Qui sizes viene allineato alla larghezza realmente resa.
  (function bannerGallerySizes() {
    var imgs = document.querySelectorAll('.banner-gallery .banner-gallery__image');
    if (!imgs.length) return;
    function sync() {
      for (var i = 0; i < imgs.length; i++) {
        var w = Math.round(imgs[i].getBoundingClientRect().width);
        if (w) imgs[i].sizes = w + 'px';
      }
    }
    sync();
    window.addEventListener('resize', sync);
  })();